// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectorSkeleton_wrapper__RPtmf","clickableBlock":"SelectorSkeleton_clickableBlock__7cTmC","value":"SelectorSkeleton_value__pcCJa"};